import { ILinkedRegisterItemResult } from '@core/entities/linkedProcesses'
import { Entity } from '@core/entities/entity'
import { plainToInstance } from 'class-transformer'
import { RegisterItemFlatPropertyData } from '@core/entities/register/RegisterItem'

export class LinkedRegisterItemResult extends Entity<ILinkedRegisterItemResult> {
  id: number

  createdOn: string

  questionId: string

  register?: { id: number; name: string }

  status: string

  uniqueId: string

  data: Array<RegisterItemFlatPropertyData>

  previewPropertyIds?: Array<string>

  public static new(payload: unknown): LinkedRegisterItemResult {
    const entity = plainToInstance(LinkedRegisterItemResult, payload)

    return entity
  }
}
